var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTentaclesHomepageWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 706,
    height: 906,
    viewBox: "0 0 706 906",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M665.982 715.33C644.573 706.945 616.146 700.968 580.451 697.214C545.008 693.646 504.363 692.658 458.77 694.436C413.176 696.215 365.575 700.984 316.154 708.491C266.732 715.998 228.391 724.284 201.82 733.468C175.031 742.685 160.568 752.043 158.398 761.325C157.075 767.345 160.411 773.105 168.658 778.79C154.828 782.01 142.629 785.653 132.18 789.031C105.39 798.248 90.9274 807.606 88.7577 816.888C86.588 826.17 96.241 835.222 117.65 843.608C138.807 851.808 167.234 857.785 202.71 861.572C238.154 865.14 278.798 866.128 324.392 864.35C369.986 862.571 417.586 857.802 467.008 850.295C516.43 842.788 554.77 834.502 581.341 825.318C597.496 819.731 609.177 814.152 616.385 808.581L616.789 808.296C617.008 808.263 616.974 808.044 617.193 808.011L686.396 752.514C690.556 748.973 693.153 745.445 693.966 741.964C696.573 732.616 687.172 723.749 665.982 715.33Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M455.295 836.341C428.795 846.735 396.056 848.441 364.396 842.837C332.735 837.234 302.307 824.241 280.506 805.239C236.905 767.315 244.455 719.728 297.377 698.939C323.876 688.544 356.615 686.839 388.276 692.442C419.936 698.046 450.365 711.039 472.165 730.041C515.766 767.965 508.217 815.552 455.295 836.341Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M455.271 667.812L373 667V823.729H437.245C469.137 823.729 501.029 816.339 525.372 801.478C549.406 786.861 561.577 767.696 561.885 748.532H597.321V667.731H455.271V667.812Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M248.306 629.75V747.419C248.306 758.22 252.081 769.02 259.63 779.009V629.75H248.306Z",
    fill: "#CACACB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M300.921 567.871C295.297 570.307 289.905 573.068 284.821 576.154C260.478 590.934 248.307 610.342 248.307 629.751C248.307 640.551 252.082 651.352 259.631 661.34L372.947 629.751L300.921 567.871Z",
    fill: "#F1ECEC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M300.92 567.871C297.839 569.17 294.835 570.632 291.984 572.175L362.47 632.755L363.471 632.512L372.946 629.832L300.92 567.871Z",
    fill: "url(#paint3_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M372.946 666.618L259.553 698.208V661.34L372.946 629.75V666.618Z",
    fill: "#CACACB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M259.553 698.208V779.09C265.562 787.049 273.958 794.601 284.743 801.179C296.144 808.081 309.163 813.441 323.029 817.095V680.505L259.553 698.208Z",
    fill: "#CACACB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M259.553 698.209C265.562 706.167 273.958 713.719 284.743 720.297C296.144 727.199 309.163 732.559 323.029 736.213L372.869 666.7L259.553 698.209Z",
    fill: "#F1ECEC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M372.946 703.405L323.105 772.919V736.132L372.946 666.619V703.405Z",
    fill: "#CACACB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M259.553 698.208H304.31L361.777 682.129L372.946 666.619L259.553 698.208Z",
    fill: "url(#paint4_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M259.553 698.208L298.301 706.572L355.768 690.574L372.946 666.619L259.553 698.208Z",
    fill: "url(#paint5_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M461.072 539.367C436.73 524.588 404.838 517.117 372.946 517.117C347.679 517.117 322.412 521.745 300.92 531.084L372.946 592.964L461.072 539.367Z",
    fill: "#59595B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M372.946 629.75L300.92 567.871V531.084L372.946 592.964V629.75Z",
    fill: "#313131"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M461.072 631.375L372.946 684.971V592.964L461.072 539.367V631.375Z",
    fill: "#313131"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M372.947 823.267C404.839 823.267 436.73 815.877 461.073 801.016C485.415 786.155 497.587 766.828 497.587 747.419V703.324C497.587 722.732 485.415 742.141 461.073 756.92C436.73 771.7 404.839 779.171 372.947 779.171C355.923 779.171 338.975 777.06 323.106 772.837V816.933C338.975 821.155 355.923 823.267 372.947 823.267Z",
    fill: "#CACACB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M372.947 703.406L323.106 772.919C338.975 777.142 355.923 779.253 372.947 779.253C404.839 779.253 436.73 771.863 461.073 757.002C485.415 742.223 497.587 722.814 497.587 703.406H372.947Z",
    fill: "#F1ECEC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M351.917 772.919L401.68 703.406H372.947L323.106 772.919H351.917Z",
    fill: "url(#paint6_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M497.586 703.406H422.787H401.68H372.869L323.029 772.919C333.736 775.761 344.983 777.629 356.384 778.522L405.531 709.984H497.047C497.355 707.791 497.586 705.598 497.586 703.406Z",
    fill: "url(#paint7_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M497.586 684.971H372.947V703.405H497.586V684.971Z",
    fill: "#CACACB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M497.587 684.972C497.587 665.564 485.415 646.155 461.073 631.375L372.947 684.972H497.587Z",
    fill: "#F1ECEC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M471.318 638.44C468.159 636.004 464.77 633.568 460.995 631.375L372.869 684.972H394.824L471.318 638.44Z",
    fill: "url(#paint8_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M467.929 635.841C465.772 634.298 463.461 632.755 461.073 631.293L372.947 684.89H387.198L467.929 635.841Z",
    fill: "url(#paint9_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M387.198 684.971L401.68 703.405H372.947V684.971H387.198Z",
    fill: "#F1ECEC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M594.878 655.818H581.475L589.948 661.015L581.475 666.131H594.878L603.352 661.015L594.878 655.818Z",
    fill: "url(#paint10_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M581.475 666.131L589.948 661.015V650.621L581.475 655.818V666.131Z",
    fill: "#CACACB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M581.475 666.131L573.001 661.015V650.621L581.475 655.818V666.131Z",
    fill: "#F1ECEC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M581.475 655.818L573.001 650.621L581.475 645.504L589.949 650.621L581.475 655.818Z",
    fill: "#59595B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M308.7 612.129H293.062L303 618.219L293.062 624.228H308.7L318.638 618.219L308.7 612.129Z",
    fill: "url(#paint11_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M293.062 624.228L303 618.219V606.119L293.062 612.128V624.228Z",
    fill: "#CACACB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M293.063 624.228L283.125 618.219V606.119L293.063 612.128V624.228Z",
    fill: "#E0E0E0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M293.063 612.129L283.125 606.119L293.063 600.11L303 606.119L293.063 612.129Z",
    fill: "#59595B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M620.839 701.375H610.825L617.141 705.192L610.825 709.09H620.839L627.156 705.192L620.839 701.375Z",
    fill: "url(#paint12_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M610.825 709.089L617.141 705.192V697.477L610.825 701.375V709.089Z",
    fill: "#59595B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M610.825 709.089L604.508 705.192V697.477L610.825 701.375V709.089Z",
    fill: "#C0162E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M610.825 701.375L604.508 697.477L610.825 693.66L617.142 697.477L610.825 701.375Z",
    fill: "#F1F1F6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M571.076 669.542H548.582L562.833 678.231L548.582 686.92H571.076L585.327 678.231L571.076 669.542Z",
    fill: "url(#paint13_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M548.582 686.92L562.833 678.231V660.853L548.582 669.542V686.92Z",
    fill: "#C0162E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M548.582 686.92L534.331 678.231V660.853L548.582 669.542V686.92Z",
    fill: "url(#paint14_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M548.582 669.542L534.331 660.853L548.582 652.163L562.834 660.853L548.582 669.542Z",
    fill: "#F2F2F7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M256.78 803.94L255.009 804.995L256.78 806.132H273.728V803.94H256.78Z",
    fill: "url(#paint15_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M274.652 814.821L272.88 815.877L274.652 817.014H291.676V814.821H274.652Z",
    fill: "url(#paint16_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M276.501 815.877L274.729 816.526L291.984 731.99L293.756 731.34L276.501 815.877Z",
    fill: "#292929"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M258.552 804.994L256.857 805.644L274.113 721.027L275.807 720.458L258.552 804.994Z",
    fill: "#292929"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M275.807 720.458L274.113 721.026L272.264 719.971L273.959 719.322L275.807 720.458Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M290.444 737.025L288.749 737.674L272.726 727.849L274.421 727.28L290.444 737.025Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M288.518 746.688L286.823 747.257L270.723 737.512L272.418 736.944L288.518 746.688Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M286.515 756.271L284.82 756.921L268.797 747.095L270.492 746.526L286.515 756.271Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M284.589 765.935L282.894 766.503L266.794 756.758L268.489 756.19L284.589 765.935Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M282.586 775.517L280.892 776.167L264.869 766.422L266.563 765.772L282.586 775.517Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M280.661 785.181L278.966 785.749L262.866 776.004L264.561 775.436L280.661 785.181Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M278.658 794.763L276.963 795.413L260.94 785.668L262.635 785.018L278.658 794.763Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M276.732 804.427L275.037 804.995L258.937 795.25L260.709 794.682L276.732 804.427Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M293.756 731.34L291.985 731.989L290.136 730.853L291.83 730.204L293.756 731.34Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M258.937 795.25L260.401 788.104L276.424 797.849L274.96 804.995L258.937 795.25ZM260.94 785.668L262.404 778.522L278.427 788.266L276.963 795.413L260.94 785.668ZM262.866 776.004L264.33 768.858L280.352 778.603L278.889 785.749L262.866 776.004ZM264.869 766.422L266.332 759.275L282.355 769.02L280.892 776.167L264.869 766.422ZM266.795 756.758L268.258 749.612L284.281 759.357L282.818 766.503L266.795 756.758ZM268.798 747.094L270.261 739.948L286.284 749.693L284.82 756.839L268.798 747.094ZM270.723 737.512L272.187 730.366L288.21 740.111L286.746 747.257L270.723 737.512ZM291.984 731.99L290.136 730.853L288.749 737.674L272.726 727.93L274.113 721.108L272.264 719.971L255.009 804.508L256.857 805.645L258.475 797.768L274.498 807.512L272.88 815.39L274.729 816.526L291.984 731.99Z",
    fill: "#292929"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M269.259 749.937C270.184 749.368 270.261 748.475 270.954 748.069C271.493 747.744 272.264 747.257 272.803 747.338C273.342 747.419 274.883 748.556 274.96 748.637C275.268 748.962 275.191 749.368 275.191 749.368C274.96 749.206 274.575 749.287 274.498 749.368C274.96 749.856 273.419 750.749 272.418 750.749C271.416 751.155 270.723 751.723 270.723 751.723L269.259 749.937Z",
    fill: "#F6D3AF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M257.319 744.983C256.549 743.765 249.616 747.176 253.93 751.48C255.856 753.348 258.167 755.378 260.324 756.515C262.095 757.489 271.031 752.048 271.031 752.048C271.801 750.993 270.184 749.044 268.874 749.856C267.488 750.749 263.251 752.292 261.71 751.723C260.478 751.317 258.398 746.689 257.319 744.983Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M268.797 809.218H250.155L248.691 813.847H268.797V809.218Z",
    fill: "url(#paint17_linear)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M245.764 812.304C245.764 808.244 248.229 808.162 248.229 808.162C248.229 808.162 249.539 808.162 251.696 807.188C253.776 806.295 256.78 806.619 255.085 809.868C255.085 809.868 255.085 809.949 255.008 809.949C254.931 810.111 254.7 810.274 254.469 810.436L249.154 813.684C248.384 814.253 245.841 813.116 245.764 812.304Z",
    fill: "#C0162E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M245.764 811.898C245.841 812.71 248.384 813.847 249.154 813.36L254.469 810.111C254.623 810.03 254.931 809.786 255.24 809.543C255.162 809.624 255.162 809.786 255.085 809.868C255.085 809.868 255.085 809.949 255.008 809.949C254.931 810.111 254.7 810.274 254.469 810.436L249.154 813.684C248.384 814.172 246.073 813.197 245.764 812.385C245.764 812.304 245.764 812.304 245.764 812.223C245.764 812.141 245.764 812.06 245.764 811.898Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M246.766 807.594C247.382 807.594 249.616 808.162 249.616 808.162C249.616 808.162 249.616 808.487 249.847 808.731L249.924 808.812C250.386 809.137 250.772 809.624 249.77 810.355C248.923 810.924 248.229 810.599 247.921 810.193C247.767 809.949 247.613 809.624 247.305 809.462C246.997 809.299 246.843 809.218 246.766 809.218V809.137C246.766 809.137 246.535 807.594 246.766 807.594Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M247.074 768.046C249.462 768.127 255.086 768.208 257.551 768.208C256.626 775.842 254.855 782.744 253.622 790.134C252.313 797.281 250.849 802.315 249.616 808.325C249.154 809.462 246.997 809.056 246.612 807.919C246.304 802.397 245.919 795.738 247.459 789.403C247.151 782.582 246.92 774.949 247.074 768.046Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M268.027 804.183C268.027 800.123 270.492 800.042 270.492 800.042C270.492 800.042 271.801 800.042 273.958 799.067C276.038 798.174 279.042 798.499 277.348 801.747C277.348 801.747 277.348 801.828 277.271 801.828C277.194 801.99 276.962 802.153 276.731 802.315L271.416 805.564C270.569 806.132 268.027 804.995 268.027 804.183Z",
    fill: "#C0162E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M268.027 803.777C268.104 804.589 270.646 805.726 271.416 805.239L276.731 801.99C276.885 801.909 277.194 801.666 277.502 801.422C277.425 801.503 277.425 801.666 277.348 801.747C277.348 801.747 277.348 801.828 277.271 801.828C277.194 801.99 276.962 802.153 276.731 802.315L271.416 805.564C270.646 806.051 268.335 805.076 268.027 804.264C268.027 804.183 268.027 804.183 268.027 804.102C268.027 804.021 268.027 803.939 268.027 803.777Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M269.029 799.473C269.645 799.473 271.879 800.042 271.879 800.042C271.879 800.042 271.879 800.366 272.11 800.61L272.187 800.691C272.649 801.016 273.034 801.503 272.033 802.234C271.185 802.803 270.492 802.478 270.184 802.072C270.03 801.828 269.876 801.503 269.568 801.341C269.26 801.179 269.106 801.097 269.029 801.097V801.016C269.029 801.016 268.72 799.473 269.029 799.473Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M263.405 774.786C261.017 775.192 249.462 769.264 247.074 769.589C246.612 784.288 257.55 783.719 267.488 782.826H267.565C267.18 788.997 267.796 795.169 268.874 800.285C269.491 801.26 271.648 801.341 271.879 800.123C272.187 794.032 273.65 788.835 273.805 781.526C273.882 774.055 268.874 774.949 263.405 774.786Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M251.695 776.898C255.162 778.765 260.246 779.496 261.171 775.436C261.556 778.522 263.867 776.735 264.098 775.436C263.79 768.452 263.482 764.229 265.099 757.651C264.868 753.916 264.637 753.348 265.253 751.236C265.099 750.505 263.096 748.881 261.633 747.257C260.092 745.552 259.014 744.009 258.166 743.765C251.233 741.816 247.073 754.809 246.919 768.939C247.305 772.756 249.307 775.273 251.695 776.898Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M254.315 744.414C255.932 743.358 256.703 740.516 257.011 738.973C257.011 738.08 257.165 737.187 257.473 736.212C258.629 732.883 261.633 730.852 264.021 731.989C268.797 734.263 266.948 736.699 265.793 739.948C264.714 743.034 262.634 744.576 260.323 744.089C260.169 744.576 260.246 745.713 260.863 746.363C259.091 747.338 256.626 746.688 255.624 746.119C254.623 745.632 253.544 745.145 254.315 744.414Z",
    fill: "#F6D3AF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M266.486 730.934C266.486 730.447 265.793 729.96 262.866 730.204C262.866 730.204 262.172 730.285 262.095 730.285C256.626 730.934 256.164 737.187 256.472 738.974C256.549 739.624 256.626 740.111 256.318 740.923C258.244 741.41 258.552 742.791 260.015 741.979C261.094 741.491 262.712 740.923 263.02 740.598C263.328 740.273 263.405 740.03 263.482 739.705C264.252 736.863 265.023 738.974 264.792 739.624C265.331 739.542 265.639 738.406 265.947 737.106C271.031 735.238 269.491 732.315 266.486 730.934Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M283.819 753.916C283.203 753.591 282.201 752.779 281.354 753.185C281.2 753.266 281.046 753.347 280.892 753.429C280.969 753.185 281.046 752.86 280.969 752.86C280.815 752.779 280.275 753.266 280.044 753.51C279.89 753.591 279.813 753.672 279.582 753.916C279.12 754.647 278.966 755.54 278.272 756.108C279.12 756.677 280.66 757.408 280.66 757.408C281.277 757.083 282.047 756.758 282.586 756.19C283.126 755.621 284.05 754.89 284.05 754.89C284.204 754.972 284.589 755.215 284.589 755.215C284.512 754.647 284.358 754.159 283.819 753.916Z",
    fill: "#F6D3AF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M265.022 750.749C263.636 749.125 257.011 753.916 261.787 757.733C266.332 761.468 268.104 762.524 270.338 763.417C272.264 764.229 280.506 757.733 280.506 757.733C281.199 756.596 279.351 754.809 278.195 755.784C276.963 756.839 272.88 758.788 271.185 758.382C269.953 758.301 266.332 752.292 265.022 750.749Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M276.501 797.849L278.273 799.067L276.886 806.132L275.037 804.995L276.501 797.849Z",
    fill: "#292929"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M606.973 772.187H579.472L574.85 778.44H606.973V772.187Z",
    fill: "url(#paint18_linear)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M615.524 764.067H586.251L583.478 768.046H615.524V764.067Z",
    fill: "url(#paint19_linear)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M585.943 758.22C587.022 757.408 588.716 758.789 589.178 760.251C589.178 760.9 588.716 761.956 588.716 761.956C588.716 761.956 586.945 766.179 586.328 766.91C585.712 767.641 583.247 768.696 582.014 767.559C581.167 766.341 582.862 765.692 583.17 764.473C583.555 762.93 583.401 761.712 583.786 760.575C584.171 759.763 585.943 758.22 585.943 758.22Z",
    fill: "#C0162E"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M589.102 759.925C589.102 760.007 589.102 760.007 589.102 759.925C589.102 760.575 588.717 761.631 588.717 761.631C588.717 761.631 586.945 765.853 586.329 766.584C585.712 767.315 583.247 768.371 582.015 767.234C581.938 767.153 581.938 767.071 581.861 767.071C581.861 767.234 581.938 767.396 582.092 767.559C583.324 768.614 585.789 767.64 586.406 766.909C587.022 766.178 588.794 761.956 588.794 761.956C588.794 761.956 589.256 760.9 589.256 760.25C589.179 760.169 589.102 760.088 589.102 759.925Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M583.016 759.194C583.555 758.788 585.712 757.976 585.712 757.976C585.712 757.976 585.866 758.22 586.174 758.382H586.251C586.791 758.382 587.792 758.951 587.176 760.088C586.02 762.28 583.324 762.199 583.632 761.143C583.863 760.494 583.324 759.6 583.016 759.194Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M583.632 761.792C583.555 761.468 583.478 760.656 584.326 760.575C585.25 760.413 586.252 760.9 586.174 761.468C585.943 762.523 583.709 762.117 583.632 761.792Z",
    fill: "#59595B"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M586.944 758.057C585.943 756.596 578.471 747.094 574.927 745.227C576.083 739.948 579.164 733.127 578.24 727.524H570.69C570.69 727.524 566.222 744.171 569.073 748.15C571.23 751.155 580.782 758.87 584.325 761.306C585.558 761.225 587.407 759.113 586.944 758.057Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M580.551 771.863C581.86 772.106 582.245 774.299 581.552 775.679C581.167 776.166 580.166 776.573 580.166 776.573C580.166 776.573 576.083 778.359 575.158 778.44C574.234 778.521 572.231 778.197 572 776.491C572.154 775.517 572.924 775.192 573.926 774.624C575.235 773.812 576.314 772.675 577.315 772.106C578.24 771.619 580.551 771.863 580.551 771.863Z",
    fill: "#C0162E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M575.158 777.953C576.083 777.872 580.32 776.085 580.32 776.085C580.32 776.085 581.321 775.679 581.706 775.192C581.629 775.354 581.629 775.517 581.552 775.679C581.167 776.166 580.166 776.572 580.166 776.572C580.166 776.572 576.083 778.359 575.158 778.44C574.234 778.521 572.231 778.197 572 776.491V776.41C572.462 777.709 574.311 778.034 575.158 777.953Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M577.778 770.401C578.394 770.482 580.551 771.457 580.551 771.457C580.551 771.457 580.551 771.781 580.628 772.106C580.628 772.106 580.628 772.187 580.705 772.187C581.09 772.593 581.475 773.243 580.32 773.649C578.009 774.38 576.083 772.756 576.93 772.269C577.546 771.944 577.701 770.888 577.778 770.401Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M576.545 772.593C576.699 772.35 577.084 771.7 577.777 772.269C578.548 772.837 578.702 773.487 578.625 774.055C578.548 774.624 577.931 774.705 577.007 774.136C576.006 773.487 576.545 772.593 576.545 772.593Z",
    fill: "#59595B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M577.238 727.199C577.238 734.67 577.161 742.953 577.161 749.449C577.161 756.921 576.622 766.097 576.699 772.35C577.855 773.812 580.705 773.487 581.321 772.35C582.091 766.665 583.709 758.057 583.324 751.886C585.096 743.765 587.33 734.101 586.636 727.686C584.942 728.254 578.933 726.63 577.238 727.199Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M575.312 697.233C569.535 699.182 568.148 705.11 567.917 709.17C567.763 711.85 567.455 721.676 571.075 719.403C574.696 717.048 575.312 697.233 575.312 697.233Z",
    fill: "#292929"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M586.328 701.456C584.865 699.507 581.167 696.746 578.779 696.584C574.696 696.259 571.461 699.832 570.613 702.837C569.843 705.598 570.228 726.793 569.381 730.61C569.843 732.64 573.31 733.695 574.619 734.02C580.397 735.32 586.944 735.157 587.407 731.259C588.254 724.032 588.485 703.73 586.328 701.456Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M564.451 734.426L575.62 727.605V714.043L564.451 720.865V734.426Z",
    fill: "#CACACB"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M564.451 734.426L553.281 727.605V714.043L564.451 720.865V734.426Z",
    fill: "#F1ECEC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M564.451 720.865L553.281 714.043L564.451 707.222L575.621 714.043L564.451 720.865Z",
    fill: "#59595B"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M573.002 721.839C572.771 722.083 571.924 724.681 573.772 725.412C574.697 724.925 575.082 722.245 573.002 721.839Z",
    fill: "#34318F"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M574.157 721.839L573.002 722.326C572.308 722.57 570.614 722.164 569.689 721.189C568.765 720.215 568.534 722.164 569.689 722.732C570.768 723.301 570.845 723.788 568.996 724.113C568.149 724.275 567.301 724.763 566.993 725.087C566.377 725.737 565.684 727.28 566.685 728.011C567.532 728.579 569.92 727.442 570.691 727.118C572.771 726.224 572.308 725.818 573.464 725.25C574.619 724.681 574.851 724.681 574.851 724.681L574.157 721.839Z",
    fill: "#F6D3AF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M583.632 700.563C584.942 700.319 586.56 700.482 587.715 704.542C588.639 707.953 587.869 714.937 587.33 716.886C585.866 721.839 580.089 723.545 573.772 725.493C574.542 724.519 574.003 722.408 573.002 721.92C577.239 719.971 581.244 717.129 582.708 715.586C582.708 713.881 581.938 707.466 581.861 705.273C581.629 702.431 582.4 700.807 583.632 700.563Z",
    fill: "#292929"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M579.241 690.818C579.395 689.437 574.85 692.28 575.004 694.147C575.158 695.609 575.543 696.99 574.157 697.883C573.695 698.289 572 700.725 574.542 701.212C578.24 701.943 579.241 700.157 581.937 697.721C580.319 696.827 578.779 695.366 579.241 690.818Z",
    fill: "#F6D3AF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M580.32 690.006L578.471 687.245H570.383V692.361C570.383 695.203 572.231 697.477 574.465 697.477C576.622 697.477 578.625 695.609 578.779 692.848L579.781 692.523L580.32 690.006Z",
    fill: "#F6D3AF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M574.619 698.939C576.545 698.939 578.933 695.69 578.702 692.93C578.625 695.447 576.622 697.314 574.542 697.558C574.388 697.721 574.234 697.802 574.08 697.964C574.003 697.964 574.003 698.045 573.926 698.127C574.003 698.451 574.234 698.939 574.619 698.939Z",
    fill: "#EBC5A3"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M570.845 684.971C570.074 684.809 570.074 684.159 573.002 683.103C574.773 682.21 577.238 681.885 578.779 682.941C580.936 684.321 581.629 686.433 581.244 689.031C580.859 691.63 579.241 694.147 579.241 694.147C579.01 694.391 578.933 693.173 579.164 692.28C579.241 692.198 579.318 691.955 579.472 691.549C580.012 688.869 578.471 689.275 578.317 689.519C577.855 689.762 578.779 691.955 577.393 691.711C576.699 691.63 576.776 689.6 576.776 688.95C576.699 688.95 576.545 689.031 576.468 689.031C575.313 689.681 571.384 690.168 573.618 688.788C572.077 688.788 570.074 689.519 569.381 688.544C568.534 687.245 569.843 685.945 570.845 684.971Z",
    fill: "#E19100"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M476.864 661.34C476.864 657.361 479.252 657.198 479.252 657.198C479.252 657.198 480.562 657.198 482.719 656.305C484.799 655.412 487.726 655.737 486.108 658.985C486.108 658.985 486.108 659.066 486.031 659.066C485.954 659.229 485.723 659.391 485.492 659.553L480.254 662.802C479.406 663.289 476.864 662.152 476.864 661.34Z",
    fill: "url(#paint20_linear)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M476.864 660.934C476.941 661.746 479.406 662.883 480.254 662.395L485.492 659.147C485.646 659.066 485.954 658.822 486.262 658.579C486.185 658.66 486.185 658.822 486.108 658.904C486.108 658.904 486.108 658.985 486.031 658.985C485.954 659.147 485.723 659.31 485.492 659.472L480.254 662.72C479.483 663.208 477.249 662.233 476.941 661.421C476.941 661.34 476.941 661.34 476.941 661.259C476.864 661.177 476.864 661.096 476.864 660.934Z",
    fill: "#1D1E67"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M477.789 656.63C478.405 656.63 480.562 657.198 480.562 657.198C480.562 657.198 480.562 657.523 480.793 657.767L480.87 657.848C481.332 658.173 481.717 658.66 480.716 659.31C479.869 659.878 479.175 659.553 478.867 659.147C478.713 658.904 478.559 658.579 478.251 658.416C477.943 658.254 477.789 658.173 477.712 658.173V658.092C477.712 658.092 477.558 656.63 477.789 656.63Z",
    fill: "#F6D3AF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M456.99 650.719C457.991 646.983 459.147 643.897 460.071 639.593C462.382 639.106 482.565 632.609 482.642 637.076C482.796 641.705 480.408 657.54 480.408 657.54C480.331 657.702 480.254 657.865 480.023 658.027C479.483 658.352 478.482 658.352 477.943 658.027C477.712 657.865 477.481 657.702 477.481 657.459C477.481 657.459 477.635 646.171 478.02 641.38C471.703 646.415 460.841 652.018 456.99 650.719Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M484.336 666.7C484.336 662.721 486.724 662.558 486.724 662.558C486.724 662.558 488.033 662.558 490.19 661.665C492.27 660.772 495.198 661.097 493.58 664.345C493.58 664.345 493.58 664.426 493.503 664.426C493.426 664.588 493.195 664.751 492.964 664.913L487.725 668.161C486.878 668.649 484.336 667.512 484.336 666.7Z",
    fill: "#313131"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M484.336 666.375C484.413 667.187 486.878 668.324 487.725 667.836L492.964 664.588C493.118 664.507 493.426 664.263 493.734 664.02C493.657 664.101 493.657 664.263 493.58 664.344C493.58 664.344 493.58 664.426 493.503 664.426C493.426 664.588 493.195 664.75 492.964 664.913L487.725 668.161C486.955 668.648 484.721 667.674 484.413 666.862C484.413 666.781 484.413 666.781 484.413 666.699C484.336 666.618 484.336 666.456 484.336 666.375Z",
    fill: "#313131"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M485.261 662.071C485.877 662.071 488.034 662.639 488.034 662.639C488.034 662.639 488.034 662.964 488.265 663.208L488.342 663.289C488.804 663.614 489.189 664.101 488.188 664.751C487.341 665.319 486.647 664.913 486.339 664.588C486.185 664.345 486.031 664.02 485.723 663.857C485.415 663.695 485.261 663.614 485.184 663.614V663.532C485.184 663.532 485.261 662.639 485.261 662.071Z",
    fill: "#F6D3AF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M467.697 645.099C470.008 644.611 488.342 635.597 490.114 639.252C490.191 639.414 490.268 639.658 490.268 639.82C491.115 644.53 488.188 662.802 488.188 662.802C488.111 662.964 488.034 663.127 487.803 663.289C487.263 663.614 486.262 663.614 485.723 663.289C485.492 663.127 485.261 662.964 485.261 662.72C485.261 662.72 484.336 650.864 484.567 646.642C478.174 652.488 468.544 655.899 465.001 655.818C458.299 655.656 455.064 651.92 453.6 647.778C453.061 646.317 452.83 642.256 452.83 640.551C459.609 637.14 465.463 641.363 467.697 645.099Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M482.257 648.59C476.017 653.3 468.082 655.98 464.924 655.899C458.222 655.737 454.987 652.001 453.523 647.859C452.984 646.398 452.753 642.337 452.753 640.632C452.676 639.17 452.676 637.79 452.676 636.409L372.869 684.971H497.509C497.586 672.465 492.425 659.878 482.257 648.59Z",
    fill: "#C0162E"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M489.421 639.332C491.038 635.11 492.579 631.049 494.043 627.233C494.12 626.989 494.043 626.664 493.735 626.502C487.726 622.848 484.722 621.061 478.79 617.407C478.713 617.326 478.636 617.326 478.559 617.326H478.944C479.021 617.326 479.098 617.326 479.252 617.407C485.261 621.061 488.265 622.848 494.197 626.502C494.428 626.664 494.582 626.989 494.505 627.233C493.041 631.131 491.501 635.11 489.883 639.332C489.806 639.495 489.652 639.576 489.498 639.576H489.113C489.19 639.576 489.344 639.495 489.421 639.332Z",
    fill: "#292929"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M473.552 629.669C473.475 629.913 473.629 630.238 473.86 630.4C479.869 634.054 482.873 635.841 488.804 639.495C489.035 639.657 489.344 639.576 489.421 639.251C491.038 635.029 492.579 630.968 494.043 627.152C494.12 626.908 494.043 626.583 493.734 626.421C487.726 622.767 484.722 620.98 478.79 617.326C478.559 617.163 478.251 617.245 478.174 617.488C476.556 621.467 474.938 625.771 473.552 629.669Z",
    fill: "#292929"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M493.581 626.908C493.272 627.72 489.344 638.033 489.036 638.845C488.188 638.358 474.862 630.237 474.014 629.75C474.322 628.938 478.251 618.543 478.559 617.731C479.407 618.3 492.81 626.421 493.581 626.908Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M476.71 630.724C475.94 630.237 475.555 629.994 474.784 629.588C475.324 628.126 475.709 627.233 476.325 625.527C477.095 626.014 477.481 626.258 478.251 626.664C477.635 628.288 477.249 629.263 476.71 630.724Z",
    fill: "#59595B"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M479.098 632.105C478.328 631.617 477.943 631.374 477.172 630.968C477.866 629.181 478.328 627.963 479.098 625.852C479.869 626.339 480.254 626.583 481.024 626.989C480.254 629.1 479.792 630.318 479.098 632.105Z",
    fill: "#292929"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M481.486 633.567C480.716 633.08 480.33 632.836 479.56 632.43C480.639 629.669 481.486 627.476 482.41 624.878C483.181 625.365 483.566 625.609 484.336 626.015C483.412 628.613 482.564 630.806 481.486 633.567Z",
    fill: "#C0162E"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M483.951 635.029C483.181 634.541 482.796 634.298 482.026 633.892C482.873 631.618 483.566 629.913 484.491 627.477C485.261 627.964 485.646 628.207 486.417 628.614C485.415 631.05 484.799 632.755 483.951 635.029Z",
    fill: "#292929"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M486.339 636.49C485.569 636.003 485.184 635.759 484.414 635.353C485.03 633.648 485.492 632.592 486.185 630.643C486.956 631.131 487.341 631.374 488.111 631.78C487.418 633.729 486.956 634.785 486.339 636.49Z",
    fill: "#59595B"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M488.728 637.952C487.957 637.465 487.572 637.221 486.802 636.815C487.957 633.892 488.805 631.618 489.806 629.02C490.576 629.507 490.962 629.75 491.732 630.156C490.73 632.755 489.883 635.029 488.728 637.952Z",
    fill: "#C0162E"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M478.713 646.235C478.482 646.398 478.097 646.398 477.789 646.235L462.844 637.14C462.613 636.978 462.613 636.734 462.844 636.572L473.013 630.4C473.244 630.238 473.629 630.238 473.937 630.4L488.882 639.495C489.113 639.658 489.113 639.901 488.882 640.064L478.713 646.235Z",
    fill: "url(#paint21_linear)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M473.937 631.618L473.244 631.212L473.552 630.968L474.323 631.455L473.937 631.618Z",
    fill: "#F1ECEC"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M475.17 632.429L474.477 631.942L474.785 631.699L475.555 632.186L475.17 632.429Z",
    fill: "#F1ECEC"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M476.403 633.161L475.71 632.674L476.018 632.512L476.788 632.917L476.403 633.161Z",
    fill: "#F1ECEC"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M477.635 633.892L476.942 633.486L477.25 633.243L478.02 633.648L477.635 633.892Z",
    fill: "#F1ECEC"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M478.868 634.623L478.175 634.217L478.483 633.973L479.253 634.46L478.868 634.623Z",
    fill: "#F1ECEC"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M480.101 635.435L479.407 634.948L479.715 634.704L480.486 635.191L480.101 635.435Z",
    fill: "#F1ECEC"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M481.333 636.165L480.64 635.679L480.948 635.516L481.718 635.922L481.333 636.165Z",
    fill: "#F1ECEC"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M482.566 636.896L481.872 636.49L482.18 636.247L482.951 636.653L482.566 636.896Z",
    fill: "#F1ECEC"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M483.798 637.627L483.105 637.222L483.413 636.978L484.183 637.465L483.798 637.627Z",
    fill: "#F1ECEC"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M485.03 638.439L484.337 637.952L484.722 637.709L485.416 638.196L485.03 638.439Z",
    fill: "#F1ECEC"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M486.263 639.17L485.57 638.683L485.955 638.521L486.648 638.927L486.263 639.17Z",
    fill: "#F1ECEC"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M487.496 639.901L486.802 639.495L487.187 639.252L487.881 639.658L487.496 639.901Z",
    fill: "#F1ECEC"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M473.321 632.754L472.011 631.942L472.705 631.536L474.014 632.348L473.321 632.754Z",
    fill: "#F1ECEC"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M472.628 633.809L470.779 632.673L471.549 632.267L473.321 633.322L472.628 633.809Z",
    fill: "#F1ECEC"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M471.857 634.866L469.546 633.405L470.317 632.999L472.628 634.379L471.857 634.866Z",
    fill: "#F1ECEC"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M469.392 635.11L468.083 634.298L469.084 633.73L470.394 634.542L469.392 635.11Z",
    fill: "#F1ECEC"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M471.241 636.246L469.931 635.435L470.856 634.867L472.242 635.597L471.241 636.246Z",
    fill: "#F1ECEC"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M473.013 637.383L471.703 636.571L472.705 635.922L474.014 636.734L473.013 637.383Z",
    fill: "#F1ECEC"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M479.329 641.119L477.943 640.388L478.944 639.739L480.254 640.551L479.329 641.119Z",
    fill: "#F1ECEC"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M482.411 643.068L479.792 641.444L480.793 640.876L483.336 642.419L482.411 643.068Z",
    fill: "#F1ECEC"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M477.481 640.064L473.552 637.628L474.554 637.059L478.482 639.414L477.481 640.064Z",
    fill: "#F1ECEC"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M474.862 633.729L473.783 633.08L474.554 632.593L475.632 633.242L474.862 633.729Z",
    fill: "#F1ECEC"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M474.168 634.704L473.09 634.054L473.86 633.649L474.939 634.298L474.168 634.704Z",
    fill: "#F1ECEC"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M473.475 635.759L472.397 635.11L473.167 634.704L474.246 635.353L473.475 635.759Z",
    fill: "#F1ECEC"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M475.093 636.734L474.015 636.084L474.708 635.598L475.786 636.328L475.093 636.734Z",
    fill: "#F1ECEC"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M476.634 637.708L475.555 637.059L476.326 636.572L477.404 637.221L476.634 637.708Z",
    fill: "#F1ECEC"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M478.251 638.682L477.173 638.033L477.866 637.546L478.944 638.196L478.251 638.682Z",
    fill: "#F1ECEC"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M479.792 639.576L478.713 638.927L479.483 638.521L480.562 639.17L479.792 639.576Z",
    fill: "#F1ECEC"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M481.41 640.55L480.331 639.901L481.024 639.495L482.103 640.145L481.41 640.55Z",
    fill: "#F1ECEC"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M483.874 642.093L481.872 640.876L482.642 640.47L484.645 641.687L483.874 642.093Z",
    fill: "#F1ECEC"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M475.786 635.678L474.708 635.029L475.401 634.623L476.479 635.272L475.786 635.678Z",
    fill: "#F1ECEC"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M477.327 636.653L476.249 636.003L477.019 635.598L478.097 636.247L477.327 636.653Z",
    fill: "#F1ECEC"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M478.944 637.627L477.866 636.978L478.559 636.491L479.638 637.14L478.944 637.627Z",
    fill: "#F1ECEC"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M480.485 638.601L479.407 637.952L480.177 637.465L481.256 638.114L480.485 638.601Z",
    fill: "#F1ECEC"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M482.103 639.576L481.024 638.927L481.717 638.44L482.796 639.089L482.103 639.576Z",
    fill: "#F1ECEC"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M485.107 641.362L482.565 639.82L483.335 639.414L485.8 640.956L485.107 641.362Z",
    fill: "#F1ECEC"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M476.479 634.703L475.401 634.054L476.094 633.567L477.173 634.217L476.479 634.703Z",
    fill: "#F1ECEC"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M478.02 635.597L476.942 634.948L477.712 634.542L478.79 635.191L478.02 635.597Z",
    fill: "#F1ECEC"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M479.638 636.572L478.56 635.922L479.253 635.516L480.331 636.166L479.638 636.572Z",
    fill: "#F1ECEC"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M481.179 637.546L480.1 636.897L480.87 636.491L481.949 637.14L481.179 637.546Z",
    fill: "#F1ECEC"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M482.796 638.521L481.718 637.871L482.411 637.384L483.49 638.033L482.796 638.521Z",
    fill: "#F1ECEC"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M484.337 639.495L483.258 638.845L484.029 638.358L485.107 639.008L484.337 639.495Z",
    fill: "#F1ECEC"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M486.262 640.631L484.876 639.82L485.569 639.333L487.033 640.226L486.262 640.631Z",
    fill: "#F1ECEC"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M486.956 638.764L475.17 631.536L475.478 631.293L487.341 638.52L486.956 638.764Z",
    fill: "#313131"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M477.481 640.957L471.472 637.303L467.698 639.577L473.706 643.231L477.481 640.957Z",
    fill: "#F1ECEC"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M488.882 639.983L478.713 646.154C478.482 646.235 478.251 646.317 478.02 646.235L477.866 646.154L462.845 637.14C462.845 637.14 462.845 637.14 462.768 637.14V637.059V637.303C462.768 637.384 462.845 637.465 462.922 637.546L477.866 646.641C478.251 646.804 478.713 646.804 478.868 646.723C479.022 646.723 479.176 646.641 479.33 646.641L488.959 640.795C489.113 640.713 489.113 640.632 489.113 640.551V639.983C489.113 639.82 489.036 639.901 488.882 639.983Z",
    fill: "#F1ECEC"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M471.087 633.649L473.321 635.029L466.388 639.252V639.495L464.154 638.115V637.871L471.087 633.649Z",
    fill: "url(#paint22_linear)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M462.151 617.326C462.382 619.112 462.074 621.386 464.847 626.746C465.694 628.451 469.007 633.08 470.162 633.892C470.547 633.323 472.011 632.674 472.242 632.511C472.473 632.349 473.398 632.268 473.937 632.593C474.091 632.674 474.476 632.917 474.707 633.161C475.169 633.567 474.707 633.973 474.168 633.892C473.629 633.811 473.475 633.973 472.936 634.46C472.859 634.542 472.781 634.623 472.704 634.704C473.013 634.542 473.552 634.217 473.86 634.623C473.552 634.866 472.55 635.435 471.703 635.516C471.472 635.597 470.547 635.516 470.085 635.435C468.314 635.11 464.385 632.511 461.766 628.695C457.221 622.198 456.759 619.437 456.759 617.813C456.759 613.59 461.843 614.321 462.151 617.326Z",
    fill: "url(#paint23_linear)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M458.453 649.078C464.077 652.407 471.241 651.027 468.622 644.287C467.158 641.038 466.619 635.435 466.696 632.024C467.235 630.725 468.93 630.4 469.7 627.071C469.854 624.472 469.931 623.497 469.469 618.381C467.466 615.864 466.465 614.727 464.231 613.753C462.844 613.184 461.073 612.453 459.763 613.265C454.062 616.92 452.291 628.126 452.83 640.632C453.369 644.774 455.68 647.372 458.453 649.078Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M460.995 613.834C461.92 612.859 462.228 610.667 462.382 608.88C462.228 607.905 462.305 606.931 462.459 605.875C463.229 602.14 466.157 599.541 468.93 600.191C471.703 600.84 473.398 604.414 472.627 608.149C471.934 611.641 469.161 613.671 466.619 613.996C466.388 614.564 467.004 615.458 467.389 615.864C465.309 616.513 463.152 615.214 462.074 614.646C461.535 614.402 461.149 614.158 460.995 613.834Z",
    fill: "#F6D3AF"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M477.943 640.388L478.328 640.47C478.713 640.47 479.021 640.713 480.562 640.145C480.947 639.982 481.563 639.414 482.025 639.414C482.565 639.414 482.95 639.414 483.181 639.333C482.95 639.414 482.488 639.495 482.025 639.576C481.563 639.657 481.024 640.307 480.639 640.551C480.408 640.713 480.177 640.794 480.023 640.876L474.399 644.286V644.53L471.78 642.906V642.662L476.402 639.82C477.095 640.063 477.558 640.307 477.943 640.388Z",
    fill: "url(#paint24_linear)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M469.546 619.112C469.777 620.899 469.854 625.853 472.627 631.212C473.475 632.918 476.325 638.115 477.789 638.602C478.02 638.521 478.251 638.521 478.636 638.034C479.175 637.384 479.714 636.978 480.023 636.653C480.408 636.897 479.868 637.628 479.56 637.871C479.56 637.871 480.177 637.628 480.716 637.465C481.024 637.384 482.411 637.222 482.642 637.222C483.874 637.303 484.105 637.628 483.335 637.79C484.645 637.79 484.259 638.196 483.797 638.277C484.259 638.44 484.182 638.765 483.489 638.846C484.105 639.171 483.566 639.414 482.102 639.414C481.64 639.414 481.024 639.983 480.639 640.145C479.098 640.714 478.79 640.47 478.405 640.47L478.02 640.389C476.248 640.064 472.319 637.059 469.7 633.324C465.155 626.827 464.308 621.386 464.308 619.762C464.231 615.377 469.315 616.108 469.546 619.112Z",
    fill: "url(#paint25_linear)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M456.219 616.351C456.065 614.402 457.606 613.671 459.146 612.128C461.611 609.773 460.456 610.179 461.611 605.794C462.767 601.409 466.233 598.161 470.624 599.785C472.858 600.597 475.632 604.251 472.396 605.713C467.235 608.068 471.857 610.504 470.547 612.859C470.008 613.915 469.315 613.428 468.93 614.889C468.544 616.27 472.011 618.706 469.161 620.574C466.388 622.361 467.158 625.852 462.998 624.878C458.838 623.985 458.684 622.442 459.686 621.467C460.687 620.493 457.529 620.006 458.684 618.625C459.994 617.244 456.373 618.138 456.219 616.351Z",
    fill: "#F2C94C"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M464.924 656.63C469.084 656.63 482.642 656.63 488.496 656.63C486.647 653.869 484.568 651.189 482.257 648.591C476.017 653.301 468.082 655.98 464.924 655.899C459.147 655.737 455.988 652.976 454.293 649.565C452.83 653.463 457.067 656.63 464.924 656.63Z",
    fill: "url(#paint26_linear)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M329.191 699.426L332.966 705.436H319.793L323.568 711.932H340.438L345.137 705.436L349.374 699.426H329.191Z",
    fill: "url(#paint27_linear)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M325.263 698.208C324.724 698.452 324.03 700.401 324.107 701.863C324.647 702.431 326.341 703.324 326.341 703.324C326.341 703.324 330.424 705.111 331.503 705.354C333.583 705.76 335.585 705.436 335.739 703.974C335.817 703.405 334.353 702.025 333.12 701.375C331.58 700.482 330.039 699.345 329.038 698.29C328.19 697.315 325.263 698.208 325.263 698.208Z",
    fill: "url(#paint28_linear)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M329.577 652.813C329.654 660.203 329.808 671.491 329.885 677.988C329.962 685.378 329.345 692.199 329.345 698.371C328.267 699.832 325.34 699.508 324.723 698.371C323.953 692.767 323.414 686.596 323.722 680.424C321.873 672.384 319.562 659.797 320.256 653.382C321.95 653.95 327.882 652.245 329.577 652.813Z",
    fill: "#313131"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M315.865 704.217C315.325 704.461 314.478 706.329 314.478 707.791C314.94 708.359 316.635 709.334 316.635 709.334C316.635 709.334 320.641 711.364 321.719 711.689C323.799 712.176 325.802 712.014 326.033 710.552C326.11 709.983 324.723 708.522 323.568 707.791C322.027 706.816 320.564 705.598 319.639 704.461C318.792 703.568 315.865 704.217 315.865 704.217Z",
    fill: "url(#paint29_linear)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M324.338 659.391C324.03 666.781 322.567 677.013 322.027 683.672C321.411 691.224 320.949 698.208 319.87 704.38C318.715 705.76 315.865 705.273 315.248 704.136C314.786 698.452 314.016 691.549 314.709 685.459C314.709 677.338 312.398 665.725 313.4 659.391C315.094 660.122 322.721 658.742 324.338 659.391Z",
    fill: "#313131"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M325.956 628.452C328.267 628.939 331.04 630.969 331.271 636.978C331.579 642.988 329.5 646.317 329.5 646.317L325.956 628.452Z",
    fill: "#828282"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M336.356 642.094C336.664 642.013 337.357 642.256 337.434 642.825C337.588 644.043 336.664 646.966 329.808 650.702C327.959 647.372 332.889 642.744 336.356 642.094Z",
    fill: "#828282"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M314.093 632.918C315.556 630.969 319.254 628.451 321.642 628.045C327.497 627.071 329.345 631.212 329.731 634.217C330.501 639.983 329.808 680.83 330.655 684.647C330.193 686.677 326.726 687.733 325.417 688.057C319.716 689.357 313.168 689.113 312.706 685.296C311.859 678.15 311.936 635.191 314.093 632.918Z",
    fill: "url(#paint30_linear)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M321.488 622.604C321.411 621.224 326.341 624.31 326.11 626.096C325.879 627.558 324.878 628.857 326.264 629.832C326.726 630.238 327.189 633.161 325.648 633.161C321.95 633.161 321.026 631.862 318.484 629.345C319.948 628.451 321.719 627.152 321.488 622.604Z",
    fill: "#F4D1AD"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M325.494 628.776C325.417 629.426 324.107 629.913 320.718 626.99C320.333 627.72 319.254 628.857 318.407 629.263C320.949 631.862 324.338 635.76 326.418 635.76C327.959 635.76 326.726 630.238 326.187 629.832C325.725 629.588 325.571 629.182 325.494 628.776Z",
    fill: "#828282"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M319.948 621.955L321.411 618.95L329.346 617.732L329.5 623.335C329.191 627.233 328.19 628.37 326.726 628.451C324.569 628.614 322.336 627.233 321.873 624.553L320.872 624.31L319.948 621.955Z",
    fill: "#F4D1AD"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M328.575 615.621C329.268 615.377 329.268 614.727 326.187 614.078C324.338 613.428 321.873 613.509 320.487 614.809C318.561 616.514 318.176 618.625 318.869 621.143C319.562 623.66 321.257 625.934 321.257 625.934C321.565 626.178 321.873 624.635 321.334 623.985C321.257 623.904 321.103 623.66 320.949 623.254C320.024 620.737 321.565 620.899 321.873 621.062C322.335 621.224 321.719 623.498 323.106 623.092C323.722 622.929 323.414 620.98 323.337 620.25C323.414 620.25 323.568 620.25 323.645 620.25C324.877 620.737 328.806 620.656 326.418 619.6C327.882 619.356 330.039 619.762 330.578 618.707C331.194 617.488 329.654 616.433 328.575 615.621Z",
    fill: "#F2C94C"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M317.251 659.797C317.79 659.96 319.562 661.99 319.562 661.99C318.484 662.396 316.558 663.37 316.558 663.37C316.25 663.046 315.71 661.99 315.71 661.99L317.251 659.797Z",
    fill: "#F4D1AD"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M313.4 633.568C314.94 630.644 320.718 631.7 318.946 637.79C317.251 643.718 312.783 649.322 312.783 649.971C312.783 650.621 318.176 660.041 318.176 660.041C318.022 661.016 317.097 662.234 315.633 662.558C313.245 661.097 307.699 653.707 308.007 649.647C308.238 645.586 311.089 637.79 313.4 633.568Z",
    fill: "url(#paint31_linear)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M323.414 622.036C323.414 623.092 324.107 625.69 325.494 625.69C326.264 625.69 326.264 625.203 326.803 624.635C327.188 624.229 328.036 623.66 329.499 623.66C329.885 624.147 330.193 627.071 328.421 628.289C326.649 629.507 324.184 628.289 323.414 627.558C322.489 626.665 322.104 622.28 322.104 622.28L323.414 622.036Z",
    fill: "#F2C94C"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M334.661 645.749L325.725 651.19L332.658 639.658L341.671 634.136L334.661 645.749Z",
    fill: "#292929"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M325.725 651.19L325.34 650.946L332.35 639.414L332.658 639.658L325.725 651.19Z",
    fill: "#313131"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M332.658 639.658L332.35 639.414L341.363 633.892L341.671 634.136L332.658 639.658Z",
    fill: "#292929"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M334.353 646.317C332.812 646.561 332.735 645.667 332.735 644.693C332.735 643.718 333.505 642.987 335.2 643.15C336.202 643.231 336.356 642.906 336.356 642.906L336.664 642.338C337.126 642.581 337.126 642.744 337.126 642.987C337.126 643.231 336.818 645.992 334.353 646.317Z",
    fill: "#F4D1AD"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M435.497 476.594C435.497 478.543 434.187 480.979 432.57 481.954L388.199 508.915C386.581 509.889 385.271 509.077 385.271 507.128V461.733C385.271 459.784 386.581 457.348 388.199 456.374L432.57 429.413C434.187 428.438 435.497 429.25 435.497 431.199V476.594Z",
    fill: "url(#paint32_linear)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M407.611 489.912L406.841 490.481V477.975L407.611 477.487V489.912Z",
    fill: "#CACACB"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M410.846 480.411L410.076 480.898V472.452L410.846 471.965V480.411Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M413.696 482.279L412.849 482.766V462.22L413.696 461.733V482.279Z",
    fill: "#59595B"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M417.317 486.501L416.47 486.989V477.325L417.317 476.838V486.501Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M420.553 480.979L419.705 481.548V465.387L420.553 464.9V480.979Z",
    fill: "#CACACB"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M423.788 474.402L422.94 474.889V458.404L423.788 457.916V474.402Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M426.946 468.879L426.176 469.448V451.095L426.946 450.608V468.879Z",
    fill: "#59595B"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M430.181 478.624L429.411 479.111V453.856L430.181 453.369V478.624Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M391.126 485.689L390.278 486.176V467.743L391.126 467.174V485.689Z",
    fill: "#CACACB"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M394.746 480.411L393.899 480.898V471.234L394.746 470.747V480.411Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M397.982 492.348L397.134 492.836V473.427L397.982 472.94V492.348Z",
    fill: "#59595B"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M401.217 485.689L400.37 486.176V474.889L401.217 474.401V485.689Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M404.452 486.583L403.605 487.151V468.798L404.452 468.311V486.583Z",
    fill: "#CACACB"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M417.086 448.659L413.234 460.028L409.383 453.369L417.086 448.659Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M387.89 502.256L432.801 474.97V474.158L387.89 501.444V502.256Z",
    fill: "#292929"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M387.89 496.165L432.801 468.879V468.067L387.89 495.353V496.165Z",
    fill: "#292929"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M387.89 490.075L432.801 462.789V461.977L387.89 489.262V490.075Z",
    fill: "#292929"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M387.89 483.984L432.801 456.698V455.886L387.89 483.172V483.984Z",
    fill: "#292929"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M387.89 477.893L432.801 450.608V449.796L387.89 477.081V477.893Z",
    fill: "#292929"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M481.024 556.015L514.071 576.154C515.766 577.129 517.076 579.646 517.076 581.676V607.256C517.076 609.286 515.689 610.098 514.071 609.124L488.188 593.289L483.951 596.781V590.771L481.024 588.985C479.329 588.01 478.02 585.493 478.02 583.463V557.883C478.02 555.771 479.406 554.959 481.024 556.015Z",
    fill: "url(#paint33_linear)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M486.108 563.892L480.254 560.319V559.1L486.108 562.674V563.892Z",
    fill: "#CACACB"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M484.799 565.353L480.254 562.511V561.293L484.799 564.135V565.353Z",
    fill: "#CACACB"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M497.586 582.731V570.794C502.979 574.123 507.447 582.163 507.447 588.74C507.447 595.318 503.056 597.998 497.586 594.75C492.194 591.42 487.726 583.381 487.726 576.803C487.726 575.504 487.88 574.367 488.188 573.392L497.586 582.731Z",
    fill: "#59595B"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M488.188 573.393C489.498 569.414 493.196 568.196 497.509 570.794V582.732L488.188 573.393Z",
    fill: "#CACACB"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M198.225 643.272V676.23L171.099 692.748C171.099 674.594 183.221 652.388 198.225 643.272Z",
    fill: "#7F7FF2"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M193.125 640.233L211.677 651.531L185.069 701.319L166 689.709C166 671.477 178.121 649.271 193.125 640.233Z",
    fill: "#313131"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M198.225 643.272V676.23L171.099 692.748C171.099 674.594 183.221 652.388 198.225 643.272Z",
    fill: "#292929"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M171.099 692.826L198.225 676.308L174.204 706.228C172.208 702.877 171.099 698.358 171.099 692.826Z",
    fill: "#59595B"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M198.225 676.308V643.35C213.229 634.233 225.351 641.635 225.351 659.868C225.351 678.1 213.229 700.228 198.225 709.344C187.804 715.656 178.787 714.019 174.204 706.306L198.225 676.308Z",
    fill: "url(#paint34_linear)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M193.125 640.233C200.664 635.636 207.464 635.246 212.342 638.285L217.146 641.168C212.268 638.363 205.616 638.831 198.225 643.35L193.125 640.233Z",
    fill: "url(#paint35_linear)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M173.465 707.864C171.765 706.695 170.287 705.137 169.104 703.111L174.204 706.228C175.386 708.254 176.865 709.812 178.565 710.981L173.465 707.864Z",
    fill: "url(#paint36_linear)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M169.104 703.111C167.108 699.761 166 695.242 166 689.71L171.1 692.826C171.1 698.358 172.208 702.877 174.204 706.228L169.104 703.111Z",
    fill: "url(#paint37_linear)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M426.762 580.322C425.442 579.787 424.02 581.714 423.918 583.426C424.122 584.069 424.832 585.032 424.832 585.032C424.832 585.032 427.878 588.992 428.792 589.528C429.605 590.063 431.839 590.812 432.752 589.314C433.057 588.243 432.448 587.494 431.839 586.423C431.026 584.925 430.519 583.212 429.706 582.142C429.097 581.393 426.762 580.322 426.762 580.322Z",
    fill: "#AE2C34"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M428.995 589.206C428.082 588.671 424.934 584.604 424.934 584.604C424.934 584.604 424.223 583.64 424.02 582.998C424.02 583.212 423.918 583.319 423.918 583.533C424.122 584.176 424.832 585.139 424.832 585.139C424.832 585.139 427.878 589.099 428.792 589.635C429.605 590.17 431.838 590.919 432.752 589.421V589.314C431.737 590.384 429.808 589.742 428.995 589.206Z",
    fill: "#121244"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M430.113 580.429C429.402 580.215 426.863 580.001 426.863 580.001C426.863 580.001 426.762 580.322 426.457 580.536C426.457 580.536 426.356 580.536 426.356 580.643C425.747 580.857 425.036 581.286 426.051 582.249C427.879 584.283 430.62 583.748 430.011 582.677C429.605 582.035 430.011 580.964 430.113 580.429Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M432.956 556.666C432.956 556.024 432.549 554.953 431.331 553.883C426.152 549.28 415.389 546.176 409.5 540.931C407.875 542.001 405.54 544.142 403.915 545.213C401.681 555.167 418.638 556.131 426.051 559.449C424.629 566.193 425.645 574.97 425.746 581.071C426.254 582.356 428.894 583.426 430.214 582.142C431.128 575.077 432.448 564.587 432.956 556.666Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M419.756 585.888C418.436 585.353 417.014 587.28 416.913 588.993C417.116 589.635 417.826 590.598 417.826 590.598C417.826 590.598 420.873 594.559 421.787 595.094C422.599 595.629 424.833 596.378 425.747 594.88C426.051 593.809 425.442 593.06 424.833 591.99C424.02 590.491 423.513 588.779 422.7 587.708C422.091 586.959 419.756 585.888 419.756 585.888Z",
    fill: "#AE2C34"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M421.888 594.773C420.974 594.237 417.826 590.17 417.826 590.17C417.826 590.17 417.116 589.207 416.913 588.565C416.913 588.779 416.811 588.886 416.811 589.1C417.014 589.742 417.725 590.705 417.725 590.705C417.725 590.705 420.771 594.666 421.685 595.201C422.497 595.736 424.731 596.485 425.645 594.987V594.88C424.63 595.95 422.7 595.308 421.888 594.773Z",
    fill: "#121244"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M423.106 585.995C422.395 585.781 419.857 585.567 419.857 585.567C419.857 585.567 419.755 585.888 419.451 586.102C419.451 586.102 419.349 586.102 419.349 586.209C418.74 586.424 418.029 586.852 419.045 587.815C420.872 589.849 423.614 589.314 423.005 588.243C422.598 587.601 422.903 586.531 423.106 585.995Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M425.848 562.232C425.848 561.59 425.442 560.52 424.223 559.449C419.045 554.847 409.602 549.066 403.611 543.714C401.986 544.785 399.651 546.925 398.026 547.996C395.792 557.951 411.429 560.948 418.943 565.015C417.522 571.759 418.537 580.537 418.639 586.638C419.146 587.922 421.786 588.993 423.106 587.708C424.122 580.644 425.442 570.154 425.848 562.232Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M424.428 543.5C424.123 543.286 423.717 543.286 423.412 543.5L406.963 553.455C406.658 553.669 406.658 553.883 406.963 554.097L418.132 560.948C418.437 561.162 418.843 561.162 419.148 560.948L435.597 550.993C435.902 550.779 435.902 550.565 435.597 550.351L424.428 543.5Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M419.147 559.449L418.335 559.984L418.741 560.198L419.553 559.77L419.147 559.449Z",
    fill: "#E8EBF5"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M420.569 558.7L419.756 559.128L420.163 559.449L420.873 558.914L420.569 558.7Z",
    fill: "#E8EBF5"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M421.889 557.844L421.077 558.378L421.483 558.592L422.295 558.058L421.889 557.844Z",
    fill: "#E8EBF5"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M423.209 556.987L422.396 557.522L422.803 557.736L423.615 557.308L423.209 556.987Z",
    fill: "#E8EBF5"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M424.529 556.238L423.818 556.666L424.224 556.987L424.935 556.452L424.529 556.238Z",
    fill: "#E8EBF5"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M425.951 555.382L425.138 555.917L425.544 556.13L426.357 555.596L425.951 555.382Z",
    fill: "#E8EBF5"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M427.271 554.525L426.458 555.06L426.864 555.274L427.677 554.846L427.271 554.525Z",
    fill: "#E8EBF5"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M428.59 553.776L427.879 554.204L428.184 554.418L428.996 553.99L428.59 553.776Z",
    fill: "#E8EBF5"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M430.012 552.92L429.2 553.348L429.606 553.669L430.418 553.134L430.012 552.92Z",
    fill: "#E8EBF5"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M431.332 552.063L430.52 552.597L430.926 552.811L431.738 552.383L431.332 552.063Z",
    fill: "#E8EBF5"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M432.652 551.314L431.84 551.741L432.246 551.955L433.058 551.528L432.652 551.314Z",
    fill: "#E8EBF5"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M434.074 550.458L433.261 550.886L433.668 551.207L434.48 550.672L434.074 550.458Z",
    fill: "#E8EBF5"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M418.437 558.272L417.015 559.127L417.827 559.662L419.249 558.806L418.437 558.272Z",
    fill: "#E8EBF5"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M417.725 557.201L415.694 558.378L416.507 558.806L418.537 557.629L417.725 557.201Z",
    fill: "#E8EBF5"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M416.913 556.024L414.375 557.522L415.187 558.058L417.726 556.452L416.913 556.024Z",
    fill: "#E8EBF5"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M414.172 555.702L412.75 556.558L413.765 557.2L415.288 556.344L414.172 555.702Z",
    fill: "#E8EBF5"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M416.202 554.418L414.679 555.381L415.796 556.023L417.218 555.167L416.202 554.418Z",
    fill: "#E8EBF5"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M418.132 553.241L416.71 554.097L417.827 554.739L419.249 553.883L418.132 553.241Z",
    fill: "#E8EBF5"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M425.036 549.066L423.615 549.922L424.63 550.564L426.153 549.708L425.036 549.066Z",
    fill: "#E8EBF5"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M428.387 547.032L425.544 548.745L426.661 549.388L429.504 547.675L428.387 547.032Z",
    fill: "#E8EBF5"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M423.006 550.243L418.741 552.92L419.756 553.562L424.123 550.886L423.006 550.243Z",
    fill: "#E8EBF5"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M420.163 557.201L419.046 557.95L419.858 558.485L420.975 557.736L420.163 557.201Z",
    fill: "#E8EBF5"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M419.451 556.131L418.233 556.773L419.045 557.307L420.264 556.559L419.451 556.131Z",
    fill: "#E8EBF5"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M418.639 554.953L417.522 555.702L418.335 556.13L419.452 555.488L418.639 554.953Z",
    fill: "#E8EBF5"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M420.366 553.883L419.249 554.632L420.061 555.167L421.178 554.418L420.366 553.883Z",
    fill: "#E8EBF5"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M422.092 552.813L420.975 553.561L421.787 554.096L422.904 553.347L422.092 552.813Z",
    fill: "#E8EBF5"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M423.818 551.849L422.701 552.491L423.513 553.026L424.63 552.277L423.818 551.849Z",
    fill: "#E8EBF5"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M425.646 550.779L424.427 551.528L425.24 551.956L426.357 551.207L425.646 550.779Z",
    fill: "#E8EBF5"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M427.372 549.708L426.154 550.457L426.966 550.885L428.083 550.243L427.372 549.708Z",
    fill: "#E8EBF5"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M430.113 547.995L427.879 549.386L428.692 549.814L430.926 548.53L430.113 547.995Z",
    fill: "#E8EBF5"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M421.178 555.06L419.959 555.809L420.772 556.237L421.99 555.488L421.178 555.06Z",
    fill: "#E8EBF5"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M422.904 553.99L421.685 554.739L422.498 555.167L423.716 554.525L422.904 553.99Z",
    fill: "#E8EBF5"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M424.63 552.92L423.412 553.668L424.224 554.203L425.442 553.454L424.63 552.92Z",
    fill: "#E8EBF5"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M426.357 551.849L425.138 552.598L425.951 553.133L427.169 552.384L426.357 551.849Z",
    fill: "#E8EBF5"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M428.082 550.886L426.864 551.528L427.676 552.063L428.895 551.314L428.082 550.886Z",
    fill: "#E8EBF5"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M431.434 548.851L428.692 550.457L429.403 550.992L432.246 549.279L431.434 548.851Z",
    fill: "#E8EBF5"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M421.888 556.131L420.771 556.88L421.584 557.414L422.701 556.666L421.888 556.131Z",
    fill: "#E8EBF5"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M423.615 555.167L422.498 555.809L423.31 556.344L424.427 555.595L423.615 555.167Z",
    fill: "#E8EBF5"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M425.341 554.097L424.224 554.739L425.036 555.274L426.153 554.525L425.341 554.097Z",
    fill: "#E8EBF5"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M427.067 553.026L425.95 553.775L426.763 554.203L427.879 553.454L427.067 553.026Z",
    fill: "#E8EBF5"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M428.794 551.956L427.677 552.705L428.489 553.133L429.606 552.491L428.794 551.956Z",
    fill: "#E8EBF5"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M430.621 550.886L429.403 551.635L430.215 552.063L431.332 551.421L430.621 550.886Z",
    fill: "#E8EBF5"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M432.652 549.601L431.129 550.564L431.941 551.099L433.465 550.136L432.652 549.601Z",
    fill: "#E8EBF5"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M433.464 551.742L420.467 559.663L420.873 559.877L433.87 551.956L433.464 551.742Z",
    fill: "#4141A8"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M423.005 549.28L416.405 553.241L412.344 550.779L418.944 546.711L423.005 549.28Z",
    fill: "#E8EBF5"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M406.962 554.097L418.131 560.948C418.335 561.055 418.639 561.055 418.944 561.055L419.147 560.948L435.596 550.993C435.596 550.993 435.596 550.993 435.698 550.993V550.886V551.1C435.698 551.207 435.596 551.314 435.495 551.421L419.045 561.376C418.639 561.59 418.131 561.59 417.928 561.483C417.725 561.483 417.624 561.376 417.421 561.376L406.861 554.954C406.759 554.847 406.657 554.74 406.657 554.632V553.99C406.759 553.883 406.861 553.99 406.962 554.097Z",
    fill: "url(#paint38_linear)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M423.919 544.25C425.138 544.999 427.879 545.427 428.59 546.069C429.402 546.819 429.504 548.959 428.996 549.602C428.387 550.244 427.778 550.244 428.082 549.602C428.387 548.959 428.285 547.675 427.372 547.568C425.544 547.354 427.879 549.495 426.965 549.495C426.153 549.495 425.848 548.424 424.833 547.675C423.919 546.926 423.208 546.712 422.295 545.855C421.584 545.106 423.919 544.25 423.919 544.25Z",
    fill: "#F4D1AD"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M412.343 516.526C417.623 521.45 417.623 533.117 418.029 533.76C418.537 534.402 421.177 540.182 424.325 544.143C424.122 544.892 422.396 546.39 422.396 546.39C420.568 545.32 416.608 541.038 415.186 538.469C413.765 535.9 412.343 516.526 412.343 516.526Z",
    fill: "#313131"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M397.925 519.63C399.549 517.489 403.611 514.492 406.251 514.278C410.719 513.957 414.273 517.81 415.186 521.129C415.999 524.233 414.983 541.145 415.999 545.32C415.491 547.568 412.445 548.745 410.922 549.066C404.626 550.565 398.737 552.063 397.62 547.996C395.589 540.61 395.589 522.092 397.925 519.63Z",
    fill: "#111416"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M405.743 507.962C405.54 506.464 410.617 509.568 410.414 511.602C410.211 513.207 409.805 514.706 411.328 515.776C411.836 516.205 413.663 518.988 410.82 519.416C407.469 519.951 404.22 517.061 402.697 515.562C404.423 514.492 406.251 512.886 405.743 507.962Z",
    fill: "#F4D1AD"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M404.525 506.999L406.555 504.002H415.389V508.712C415.389 512.565 413.359 515.241 410.922 515.241C408.586 515.241 406.352 513.207 406.251 510.21L405.134 509.782L404.525 506.999Z",
    fill: "#F4D1AD"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M410.82 516.74C408.688 516.74 406.048 513.1 406.352 510.21C406.454 512.993 408.688 515.027 410.922 515.241C411.125 515.455 411.226 515.562 411.429 515.669L411.531 515.776C411.429 516.311 411.125 516.74 410.82 516.74Z",
    fill: "#E9C3A1"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M416.304 549.602C418.131 550.993 418.639 550.137 419.655 550.565C420.67 550.993 421.584 551.742 421.99 552.064C422.295 552.278 421.178 552.278 420.67 552.064C421.787 553.027 421.888 554.419 421.685 554.954C421.482 555.596 419.858 556.238 419.451 555.917C417.928 554.311 418.131 553.669 416.101 553.134C415.39 552.92 414.273 551.742 414.273 551.742L416.304 549.602Z",
    fill: "#F4D1AD"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M400.26 518.881C398.534 518.56 397.113 519.416 396.808 522.413C396.3 527.337 400.159 537.72 401.784 540.396C403.408 543.072 413.156 551.849 414.374 552.385C414.882 551.635 416.507 549.495 416.608 549.387C415.39 547.996 407.571 538.362 406.657 535.579C405.236 531.833 405.642 519.844 400.26 518.881Z",
    fill: "#292929"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M439.556 543.072L423.716 552.705C423.411 552.812 423.208 553.134 423.107 553.348L419.045 560.626C418.944 560.734 419.147 560.948 419.248 560.841L435.799 550.779C435.901 550.672 436.002 550.565 436.104 550.458L439.962 543.607C440.165 543.179 439.962 542.858 439.556 543.072Z",
    fill: "black"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M419.045 560.627L423.107 553.348C423.208 553.027 423.513 552.813 423.716 552.706L439.556 543.072C439.759 542.965 439.861 542.965 439.962 543.072C439.962 543.072 439.861 542.965 439.759 542.858C439.658 542.751 439.556 542.751 439.353 542.858L423.513 552.492C423.208 552.599 423.005 552.92 422.904 553.134L418.842 560.413C418.842 560.52 418.842 560.52 418.842 560.627C418.944 560.734 419.045 560.841 419.045 560.841C419.045 560.734 419.045 560.734 419.045 560.627Z",
    fill: "#292929"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M413.663 506.357C416.912 508.284 421.786 505.715 416.912 502.503C412.343 499.506 408.688 498.757 406.149 502.075C402.189 506.999 405.032 513.314 405.337 512.779C406.352 511.281 405.337 509.14 407.063 508.712C406.961 507.641 407.165 505.393 407.977 506.999C408.789 508.819 409.398 506.357 409.703 505.393C410.008 504.537 411.125 504.858 413.663 506.357Z",
    fill: "black"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M457.944 735.739C457.75 735.332 457.493 734.992 457.17 734.584C456.139 733.497 458.524 731.663 459.619 730.984L456.461 729.013H447.052C446.408 728.198 446.279 727.043 446.279 726.432H441.768C441.768 727.179 441.446 728.945 440.221 729.693C439.963 729.829 439.641 729.965 439.319 730.032C438.675 730.168 438.03 730.304 437.45 730.508C437.386 730.508 437.386 730.508 437.386 730.508C436.806 730.304 436.161 730.168 435.517 730.032C433.519 729.693 433.068 727.383 433.068 726.432H428.557C428.557 727.179 428.234 728.945 427.01 729.693C426.752 729.829 426.43 729.965 426.108 730.032C425.463 730.168 424.819 730.304 424.239 730.508C422.177 730.984 419.405 729.693 418.374 729.013L415.152 730.984C416.248 731.663 418.632 733.497 417.601 734.584C417.279 734.924 417.021 735.332 416.828 735.739C416.763 735.943 416.57 736.147 416.312 736.283C415.088 737.03 412.252 737.234 410.963 737.234V740.019C412.51 740.019 416.312 740.291 416.828 741.514C417.021 741.922 417.279 742.261 417.601 742.669C418.632 743.756 416.248 745.59 415.152 746.27L418.31 748.24C418.439 748.172 418.568 748.104 418.697 748.036L418.31 748.24H427.719C428.363 749.055 428.492 750.21 428.492 750.821H446.215L450.661 748.24H456.461L459.684 746.27C458.588 745.59 456.204 743.756 457.235 742.669C457.428 742.465 457.557 742.193 457.75 741.989H460.715L463.937 740.019V737.234C462.133 737.302 458.459 736.962 457.944 735.739Z",
    fill: "url(#paint39_linear)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M417.73 725.888C417.73 724.801 415.925 723.443 415.023 722.899V730.916C415.925 731.459 417.73 732.818 417.73 733.905V725.888Z",
    fill: "#CACACB"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M446.408 730.984V722.967C445.506 723.511 443.702 724.869 443.702 725.956V733.973C443.702 732.886 445.506 731.527 446.408 730.984Z",
    fill: "#CACACB"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M425.077 735.128C428.235 733.226 433.261 733.226 436.419 735.128C437.966 736.079 438.739 737.302 438.739 738.525V730.508C438.739 729.285 437.966 727.995 436.419 727.043C433.326 725.141 428.235 725.141 425.077 727.043C423.53 727.995 422.692 729.285 422.692 730.508V738.525C422.692 737.37 423.466 736.079 425.077 735.128Z",
    fill: "url(#paint40_linear)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M418.181 740.087L414.959 738.185V746.201L418.181 748.172V740.087Z",
    fill: "#CACACB"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M446.344 746.201L446.279 738.185L443.122 740.087V748.172L446.344 746.201Z",
    fill: "#CACACB"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M424.045 746.677C424.625 746.881 425.27 747.017 425.914 747.153C427.912 747.492 428.363 749.734 428.363 750.685V742.669C428.363 741.718 427.912 739.408 425.914 739.136C425.27 739 424.625 738.864 424.045 738.661C422.241 738.049 419.212 739.476 418.116 740.155V748.172C419.276 747.492 422.305 745.998 424.045 746.677Z",
    fill: "url(#paint41_linear)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M434.421 747.492C434.679 747.356 435.001 747.221 435.324 747.153C435.968 747.017 436.613 746.881 437.193 746.677C438.997 745.998 442.026 747.492 443.057 748.172V740.155C441.962 739.476 438.997 738.049 437.193 738.661C436.548 738.864 435.968 739 435.324 739.136C435.001 739.204 434.679 739.34 434.421 739.476C433.197 740.223 432.939 741.922 432.875 742.737V750.753C432.939 749.938 433.197 748.24 434.421 747.492Z",
    fill: "url(#paint42_linear)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M417.408 734.584C418.439 735.671 416.055 737.506 414.959 738.185L418.117 740.155C419.213 739.476 422.242 738.049 424.046 738.66C424.626 738.864 425.27 739 425.915 739.136C427.913 739.476 428.364 741.786 428.364 742.737H432.875C432.939 741.921 433.197 740.223 434.422 739.476C434.679 739.34 435.002 739.204 435.324 739.136C435.968 739 436.613 738.864 437.193 738.66C438.997 737.981 442.026 739.476 443.057 740.155L446.28 738.185C445.184 737.506 442.8 735.671 443.831 734.584C444.153 734.177 444.411 733.837 444.604 733.429C444.668 733.226 444.862 733.022 445.12 732.886C446.344 732.139 449.18 731.935 450.469 731.935V729.149C448.793 729.217 445.12 728.878 444.604 727.655C444.411 727.247 444.153 726.907 443.831 726.5C442.8 725.413 445.184 723.579 446.28 722.899L443.122 720.929C442.026 721.608 438.997 723.035 437.193 722.424C436.613 722.22 435.968 722.084 435.324 721.948C433.326 721.608 432.875 719.299 432.875 718.348H428.364C428.364 719.095 428.042 720.861 426.817 721.608C426.559 721.744 426.237 721.88 425.915 721.948C425.27 722.084 424.626 722.22 424.046 722.424C421.984 722.899 419.213 721.608 418.181 720.929L414.959 722.899C416.055 723.579 418.439 725.413 417.408 726.5C417.086 726.84 416.828 727.247 416.635 727.655C416.57 727.859 416.377 728.062 416.119 728.198C414.895 728.946 412.059 729.149 410.77 729.149V731.935C412.317 731.935 416.119 732.207 416.635 733.429C416.893 733.837 417.15 734.177 417.408 734.584ZM425.013 727.111C428.17 725.209 433.197 725.209 436.355 727.111C439.448 729.014 439.448 732.139 436.291 734.041C433.133 735.943 428.106 735.943 424.948 734.041C421.855 732.071 421.919 729.014 425.013 727.111Z",
    fill: "#F1ECEC"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M414.959 738.185C416.054 737.505 418.439 735.671 417.408 734.584C417.085 734.177 416.828 733.837 416.634 733.429C416.119 732.206 412.316 731.935 410.77 731.935V739.951C411.736 739.951 413.541 740.019 414.959 740.427V738.185Z",
    fill: "#CACACB"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M432.874 750.753V742.669H428.363V750.753H432.874Z",
    fill: "#CACACB"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M450.597 739.951V731.935C449.308 731.935 446.473 732.138 445.248 732.886C444.991 733.022 444.797 733.225 444.733 733.429C444.539 733.837 444.282 734.177 443.959 734.584C442.928 735.671 445.313 737.505 446.408 738.185V740.495C447.697 740.087 449.631 739.951 450.597 739.951Z",
    fill: "url(#paint43_linear)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M507.068 820.159H476.545L486.935 826.515L476.545 832.815H507.068L517.458 826.515L507.068 820.159Z",
    fill: "url(#paint44_linear)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M488.12 832.815H459.373L469.763 839.114L459.373 845.47H488.12L498.509 839.114L488.12 832.815Z",
    fill: "url(#paint45_linear)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M467.879 845.47H442.201L452.59 851.769L442.201 858.125H467.879L478.268 851.769L467.879 845.47Z",
    fill: "url(#paint46_linear)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M466.156 803.475L476.546 809.774V832.815L466.156 826.515V803.475Z",
    fill: "#E0E0E0"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M486.935 803.475L476.546 809.774V832.815L486.935 826.515V803.475Z",
    fill: "url(#paint47_linear)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M476.545 797.118L466.156 803.475L476.545 809.774L486.935 803.475L476.545 797.118Z",
    fill: "#BDBDBD"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M448.984 822.316L459.374 828.672V845.47L448.984 839.114V822.316Z",
    fill: "#E0E0E0"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M469.764 822.316L459.374 828.672V845.47L469.764 839.114V822.316Z",
    fill: "#59595B"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M459.374 816.016L448.985 822.316L459.374 828.672L469.764 822.316L459.374 816.016Z",
    fill: "#BDBDBD"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M455.203 846.719H440.729L449.927 852.282L440.729 857.883H455.203L464.364 852.282L455.203 846.719Z",
    fill: "url(#paint48_linear)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M440.729 857.883L449.927 852.282V840.963L440.729 846.526V857.883Z",
    fill: "#292929"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M440.729 857.883L431.569 852.282V840.963L440.729 846.526V857.883Z",
    fill: "#C9C9CA"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M440.73 846.526L431.569 840.963L440.73 835.362L449.927 840.963L440.73 846.526Z",
    fill: "#EFEBEB"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M447.172 285.34C416.499 318.455 420.945 277.924 451.032 256.412C481.119 234.9 502.061 250.242 540.734 258.234C579.406 266.227 616.453 225.5 583.428 172.022C550.404 118.545 465.998 127.05 339.848 229.101C213.702 331.157 165.671 488.45 -29.2284 639.284C-224.127 790.118 -314.418 759.413 -314.418 759.413C-314.418 759.413 -358.375 744.408 -420.443 682.046C-482.507 619.689 -518.667 604.499 -518.667 604.499C-518.667 604.499 -438.629 569.188 -285.46 523.748C-132.284 478.304 106.86 285.695 186.067 210.725C265.281 135.751 470.264 17.9285 583.939 100.913C697.619 183.893 630.921 301.966 556.714 305.589C482.521 309.205 477.845 252.226 447.172 285.34ZM188.385 378.644C196.561 369.198 200.184 358.627 196.478 355.034C192.773 351.441 183.134 356.19 174.958 365.635C166.783 375.081 163.16 385.653 166.865 389.246C170.577 392.836 180.21 388.09 188.385 378.644ZM142.698 436.891C152.468 426.92 157.278 415.386 153.45 411.116C149.621 406.847 138.592 411.469 128.822 421.44C119.049 431.404 114.241 442.944 118.07 447.214C121.906 451.48 132.928 446.861 142.698 436.891ZM-2.20981 505.923C-10.8007 494.626 -34.6414 497.681 -55.4497 512.757C-76.2612 527.826 -86.168 549.207 -77.574 560.51C-68.98 571.813 -45.1423 568.752 -24.334 553.676C-3.51904 538.598 6.3842 517.226 -2.20981 505.923ZM91.787 498.856C102.656 487.767 108.008 474.931 103.747 470.19C99.486 465.448 87.2199 470.581 76.3573 481.667C65.4948 492.752 60.136 505.592 64.3971 510.333C68.6547 515.084 80.9244 509.942 91.787 498.856ZM-96.0074 650.093C-99.3877 641.109 -119.191 642.525 -140.233 653.252C-161.275 663.979 -175.592 679.956 -172.212 688.939C-168.832 697.923 -149.029 696.506 -127.987 685.78C-106.941 675.043 -92.6206 659.073 -96.0074 650.093ZM-285.056 736.502C-282.94 746.203 -262.672 747.406 -239.789 739.187C-216.906 730.968 -200.065 716.44 -202.172 706.742C-204.289 697.041 -224.551 695.835 -247.44 704.057C-270.332 712.273 -287.173 726.801 -285.056 736.502ZM-53.2967 598.526C-68.9048 608.755 -78.6954 622.48 -75.1639 629.19C-71.6259 635.897 -56.1026 633.046 -40.488 622.814C-24.8799 612.585 -15.0894 598.86 -18.6209 592.15C-22.1654 585.446 -37.6887 588.297 -53.2967 598.526ZM-1.67783 573.186C2.34427 578.866 16.2454 574.628 29.3706 563.708C42.4892 552.791 49.8596 539.336 45.8343 533.649C41.8121 527.968 27.911 532.206 14.7859 543.127C1.66069 554.047 -5.70968 567.502 -1.67783 573.186ZM-104.959 582.432C-112.077 567.013 -140.503 565.131 -168.44 578.222C-196.378 591.313 -213.255 614.426 -206.13 629.841C-199.006 645.256 -170.586 647.142 -142.649 634.051C-114.711 620.96 -97.834 597.847 -104.959 582.432ZM-367.759 688.163C-361.591 708.044 -327.627 714.444 -291.901 702.46C-256.175 690.476 -232.204 664.642 -238.372 644.761C-244.54 624.881 -278.504 618.48 -314.23 630.464C-349.959 642.442 -373.924 668.273 -367.759 688.163ZM37.8878 430.265C20.0393 446.38 13.1459 467.21 22.4876 476.789C31.8292 486.368 53.8699 481.062 71.7119 464.95C89.5539 448.837 96.447 428.007 87.1119 418.425C77.7734 408.852 55.7298 414.152 37.8878 430.265ZM117.23 355.864C104.025 368.697 99.3725 384.82 106.844 391.883C114.313 398.94 131.086 394.262 144.291 381.428C157.495 368.595 162.148 352.473 154.676 345.41C147.204 338.347 130.441 343.028 117.23 355.864ZM186.406 293.101C174.165 303.985 169.346 318.135 175.649 324.711C181.952 331.287 196.981 327.796 209.223 316.912C221.464 306.029 226.283 291.879 219.98 285.303C213.677 278.727 198.648 282.218 186.406 293.101ZM321.828 212.592C330.165 206.692 334.195 198.239 330.839 193.712C327.482 189.184 318.005 190.292 309.674 196.188C301.337 202.088 297.307 210.542 300.663 215.069C304.016 219.606 313.497 218.489 321.828 212.592ZM278.871 235.541C274.661 230.318 263.431 232.047 253.794 239.399C244.156 246.752 239.751 256.946 243.961 262.168C248.17 267.39 259.4 265.663 269.038 258.31C278.675 250.957 283.08 240.763 278.871 235.541Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3169 549.778L27.7864 543.382L24.8902 545.599L26.7069 548.156L14.4368 557.535L12.7333 555.135L9.8362 557.343L15.8707 565.872L18.7669 563.655L17.1503 561.374L32.3169 549.778Z",
    fill: "#59595B"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4776 440.455L65.6099 431.115L61.3918 434.473L64.1393 438.212L46.255 452.431L43.6674 448.912L39.4493 452.269L48.6037 464.717L52.8275 461.364L50.3752 458.03L72.4776 440.455Z",
    fill: "#59595B"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.494 200.434L320.259 196.36L318.4 197.93L319.696 199.557L311.819 206.198L310.601 204.661L308.742 206.23L313.057 211.663L314.916 210.094L313.759 208.644L323.494 200.434Z",
    fill: "#59595B"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9608 480.281C89.8632 479.938 91.5644 480.429 93.074 481.758C94.5836 483.088 95.2384 484.655 95.044 486.473C94.8065 488.675 93.2499 491.26 90.3877 494.222C87.4659 497.245 84.9724 498.94 82.9073 499.305C80.8421 499.671 79.0531 499.186 77.5338 497.854C76.0242 496.524 75.3696 494.957 75.564 493.139C75.8015 490.938 77.3644 488.349 80.24 485.365C83.1319 482.38 85.7001 480.685 87.9608 480.281ZM87.3228 484.545C86.4685 485.076 85.1502 486.268 83.3646 488.115C81.5791 489.963 80.419 491.367 79.8714 492.318C79.448 493.059 79.2639 493.669 79.3196 494.149C79.3752 494.629 79.5882 495.028 79.9521 495.35C80.3127 495.666 80.7477 495.836 81.2441 495.851C81.747 495.863 82.4207 495.61 83.275 495.08C84.1293 494.549 85.4477 493.357 87.2332 491.509C89.0188 489.662 90.1854 488.255 90.7364 487.294C91.1598 486.553 91.3437 485.943 91.2881 485.463C91.2325 484.983 91.0196 484.584 90.6558 484.262C90.2951 483.946 89.8601 483.776 89.3572 483.764C88.8508 483.762 88.1771 484.015 87.3228 484.545Z",
    fill: "#59595B"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.548 420.939C140.164 420.65 141.61 421.064 142.893 422.193C144.173 423.317 144.734 424.654 144.565 426.197C144.363 428.065 143.044 430.259 140.61 432.778C138.132 435.343 136.013 436.784 134.258 437.09C132.502 437.397 130.984 436.989 129.698 435.853C128.418 434.73 127.857 433.392 128.026 431.849C128.228 429.982 129.553 427.785 131.998 425.252C134.442 422.72 136.629 421.283 138.548 420.939ZM134.643 427.586C133.129 429.156 132.142 430.347 131.678 431.155C131.319 431.779 131.163 432.298 131.21 432.713C131.261 433.118 131.436 433.46 131.742 433.734C132.045 434.003 132.416 434.144 132.838 434.159C133.266 434.171 133.835 433.956 134.564 433.505C135.287 433.057 136.407 432.044 137.921 430.474C139.435 428.904 140.429 427.709 140.896 426.892C141.255 426.268 141.412 425.749 141.365 425.334C141.314 424.929 141.139 424.587 140.832 424.313C140.529 424.044 140.159 423.903 139.73 423.892C139.302 423.88 138.727 424.098 138.004 424.546C137.281 425.009 136.157 426.016 134.643 427.586Z",
    fill: "#59595B"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.359 364.523C185.975 364.234 187.421 364.648 188.704 365.778C189.984 366.901 190.546 368.239 190.376 369.782C190.175 371.65 188.856 373.844 186.422 376.363C183.944 378.928 181.825 380.368 180.069 380.675C178.314 380.982 176.796 380.574 175.51 379.438C174.23 378.315 173.669 376.977 173.838 375.434C174.04 373.566 175.365 371.369 177.809 368.837C180.261 366.301 182.438 364.861 184.359 364.523ZM180.462 371.167C178.948 372.737 177.961 373.929 177.497 374.737C177.138 375.36 176.981 375.879 177.029 376.294C177.076 376.709 177.254 377.042 177.567 377.313C177.87 377.581 178.241 377.722 178.663 377.737C179.084 377.752 179.66 377.534 180.389 377.083C181.112 376.635 182.232 375.622 183.746 374.052C185.26 372.482 186.254 371.287 186.721 370.47C187.08 369.847 187.236 369.327 187.189 368.912C187.139 368.507 186.964 368.165 186.651 367.894C186.348 367.626 185.977 367.484 185.549 367.473C185.12 367.461 184.545 367.679 183.822 368.127C183.092 368.594 181.976 369.597 180.462 371.167Z",
    fill: "#59595B"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.692 356.277C136.027 355.83 138.123 356.431 139.97 358.077C141.817 359.724 142.621 361.685 142.368 363.955C142.063 366.71 140.152 369.955 136.619 373.693C133.026 377.499 129.957 379.643 127.419 380.108C124.878 380.584 122.685 379.986 120.828 378.339C118.981 376.693 118.177 374.731 118.429 372.461C118.734 369.706 120.657 366.453 124.198 362.7C127.751 358.939 130.922 356.799 133.692 356.277ZM128.031 366.112C125.836 368.439 124.396 370.202 123.732 371.401C123.21 372.33 122.977 373.095 123.054 373.697C123.125 374.304 123.378 374.797 123.825 375.194C124.268 375.585 124.798 375.796 125.415 375.81C126.032 375.824 126.861 375.501 127.91 374.827C128.959 374.153 130.581 372.658 132.776 370.33C134.971 368.003 136.413 366.231 137.094 365.029C137.616 364.099 137.848 363.334 137.771 362.732C137.704 362.131 137.447 361.633 137.001 361.236C136.558 360.844 136.031 360.64 135.408 360.63C134.785 360.62 133.95 360.947 132.907 361.616C131.848 362.289 130.227 363.785 128.031 366.112Z",
    fill: "#59595B"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.482 294.018C205.624 294.045 207.363 294.949 208.695 296.739C210.027 298.529 210.373 300.416 209.747 302.394C208.98 304.79 206.704 307.328 202.909 310.021C199.041 312.767 195.948 314.114 193.621 314.082C191.294 314.05 189.465 313.132 188.127 311.329C186.795 309.539 186.448 307.652 187.074 305.675C187.841 303.278 190.131 300.733 193.939 298.033C197.757 295.321 200.938 293.982 203.482 294.018ZM196.694 301.744C194.331 303.418 192.744 304.732 191.937 305.677C191.303 306.411 190.966 307.046 190.916 307.595C190.866 308.145 191 308.631 191.319 309.06C191.639 309.49 192.069 309.762 192.605 309.888C193.141 310.014 193.94 309.874 194.986 309.461C196.036 309.054 197.738 308.012 200.101 306.338C202.464 304.664 204.058 303.346 204.871 302.397C205.506 301.664 205.843 301.029 205.892 300.479C205.942 299.93 205.809 299.444 205.489 299.015C205.17 298.585 204.74 298.312 204.197 298.19C203.654 298.068 202.859 298.213 201.809 298.621C200.759 299.028 199.054 300.064 196.694 301.744Z",
    fill: "#59595B"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.9 242.481C267.507 242.497 268.808 243.178 269.814 244.527C270.811 245.872 271.072 247.287 270.599 248.77C270.022 250.568 268.31 252.478 265.459 254.495C262.556 256.553 260.229 257.569 258.486 257.546C256.74 257.517 255.361 256.829 254.361 255.477C253.365 254.131 253.097 252.721 253.577 251.234C254.154 249.436 255.872 247.522 258.733 245.493C261.606 243.458 263.992 242.458 265.9 242.481ZM260.808 248.281C259.034 249.538 257.843 250.526 257.238 251.236C256.767 251.786 256.508 252.266 256.47 252.678C256.433 253.09 256.536 253.453 256.777 253.777C257.017 254.1 257.338 254.306 257.742 254.399C258.146 254.492 258.745 254.385 259.527 254.085C260.315 253.781 261.593 252.994 263.367 251.738C265.141 250.482 266.332 249.494 266.95 248.777C267.422 248.227 267.681 247.747 267.718 247.335C267.755 246.923 267.652 246.56 267.412 246.236C267.171 245.913 266.851 245.708 266.44 245.618C266.03 245.528 265.43 245.634 264.652 245.941C263.86 246.239 262.579 247.019 260.808 248.281Z",
    fill: "#59595B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 379.23,
    y1: 698.909,
    x2: 403.687,
    y2: 859.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 376.336,
    y1: 689.294,
    x2: 376.336,
    y2: 845.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 485.16,
    y1: 667,
    x2: 485.16,
    y2: 823.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 332.465,
    y1: 567.871,
    x2: 332.465,
    y2: 632.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 316.25,
    y1: 666.619,
    x2: 316.25,
    y2: 698.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 316.25,
    y1: 666.619,
    x2: 316.25,
    y2: 706.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 362.393,
    y1: 703.406,
    x2: 362.393,
    y2: 772.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 410.307,
    y1: 703.406,
    x2: 410.307,
    y2: 778.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 422.093,
    y1: 631.375,
    x2: 422.093,
    y2: 684.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 420.438,
    y1: 631.293,
    x2: 420.438,
    y2: 684.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 592.413,
    y1: 655.818,
    x2: 592.413,
    y2: 666.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 305.85,
    y1: 612.129,
    x2: 305.85,
    y2: 624.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 618.99,
    y1: 701.375,
    x2: 618.99,
    y2: 709.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 566.954,
    y1: 669.542,
    x2: 566.954,
    y2: 686.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 548.582,
    y1: 671.675,
    x2: 522.876,
    y2: 684.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 264.368,
    y1: 803.94,
    x2: 264.368,
    y2: 806.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 282.278,
    y1: 814.821,
    x2: 282.278,
    y2: 817.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 258.744,
    y1: 809.218,
    x2: 258.744,
    y2: 813.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 590.912,
    y1: 772.187,
    x2: 590.912,
    y2: 778.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 599.501,
    y1: 764.067,
    x2: 599.501,
    y2: 768.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 486.544,
    y1: 659.356,
    x2: 476.827,
    y2: 659.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5557BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#3D3D98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 475.863,
    y1: 630.278,
    x2: 475.863,
    y2: 646.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 468.737,
    y1: 633.649,
    x2: 468.737,
    y2: 639.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 474.933,
    y1: 625.291,
    x2: 456.788,
    y2: 625.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6D3AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0227302,
    stopColor: "#F5D2AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2988,
    stopColor: "#ECC49D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6049,
    stopColor: "#E7BC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5B990"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 477.48,
    y1: 639.333,
    x2: 477.48,
    y2: 644.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 484.914,
    y1: 637.346,
    x2: 461.689,
    y2: 622.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6D3AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4046,
    stopColor: "#F4D1AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7023,
    stopColor: "#EFC9A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9654,
    stopColor: "#E6BB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5B990"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 471.252,
    y1: 648.591,
    x2: 471.252,
    y2: 656.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 319.757,
    y1: 705.677,
    x2: 349.375,
    y2: 705.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5591,
    stopColor: "#F2F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 329.901,
    y1: 705.516,
    x2: 329.901,
    y2: 697.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 320.236,
    y1: 711.936,
    x2: 320.236,
    y2: 703.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 330.655,
    y1: 653.169,
    x2: 291.942,
    y2: 663.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 313.637,
    y1: 632.005,
    x2: 313.637,
    y2: 662.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E6B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 410.356,
    y1: 493.419,
    x2: 388.327,
    y2: 461.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 497.548,
    y1: 555.554,
    x2: 497.548,
    y2: 609.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 199.777,
    y1: 639.447,
    x2: 199.777,
    y2: 713.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 205.136,
    y1: 636.328,
    x2: 205.136,
    y2: 643.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 173.834,
    y1: 703.111,
    x2: 173.834,
    y2: 710.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 174.204,
    y1: 696.567,
    x2: 158.863,
    y2: 703.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 435.771,
    y1: 555.982,
    x2: 406.78,
    y2: 555.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5618,
    stopColor: "#A5AAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#CED1F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 437.45,
    y1: 726.432,
    x2: 437.45,
    y2: 750.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 438.739,
    y1: 730.976,
    x2: 423.05,
    y2: 748.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 428.363,
    y1: 743.566,
    x2: 413.897,
    y2: 754.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 443.057,
    y1: 743.594,
    x2: 428.554,
    y2: 754.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 450.597,
    y1: 735.488,
    x2: 440.546,
    y2: 742.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 497.002,
    y1: 820.159,
    x2: 497.002,
    y2: 832.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 478.941,
    y1: 832.815,
    x2: 478.941,
    y2: 845.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 460.235,
    y1: 845.47,
    x2: 460.235,
    y2: 858.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 481.722,
    y1: 832.815,
    x2: 481.722,
    y2: 803.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 452.547,
    y1: 846.719,
    x2: 452.547,
    y2: 857.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTentaclesHomepageWork);
export default __webpack_public_path__ + "static/media/tentacles-homepage-work.1a6d1f5643ffdbcce20949d2ff2c7f35.svg";
export { ForwardRef as ReactComponent };